import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ArticleSuggestions from '../../my-articles//article-suggestions/article-suggestions';
import NewsletterArticle from './newsletter-article';
import LoadingIndication from '../../common/loading-indicator';
import NewslettersNavigationBar from './newsletters-navigation-bar';
import SiteSubscription from '../../common/site-subscription';
import CustomReadingProgress from '../../common/custom-reading-progress';
import AnimatedWrapper from '../../core/animated-wrapper';
import shareService from '../../../services/share';
import newslettersService from '../../../services/newsletters';
import formattersService from '../../../services/formatters';
import TwitterFollowButton from '../../common/twitter-follow-button';
import TeamMemberBox from '../../common/team-member-box';
import EmbededTweetBox from '../../common/embeded-tweet-box';
import SmartAd from '../../ads/smart-ad';
import universalTagNamesService from '../../../services/universal-tag-names';

import './newsletter.css';

class Newsletter extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      isLoading: true
    };   

    this._pullNewsletterByProps(props);  
  }

  // componentDidUpdate(props) {
  // }

  _pullNewsletterByProps(props) {
    const newsletterId = props.match.params.id;
    const tag = props.match.params.tag;
    
    this.setState({
      crawledResourcesCounts: undefined,
      isLoading: true,
      isError: false,
      _id: newsletterId,
      tweets: [],
      articles: [],       
      tag,
    });

    let twitterTags;
    let publicName;

    if (tag) {
      twitterTags = universalTagNamesService.getTwitterTagsByTagForNewsletter(tag);
      publicName = universalTagNamesService.getPublicTagName(tag);
    }
    else {
      publicName = 'Angular TypeScript',
      twitterTags = ['angular', 'typescript', 'javascript'];
    }
    
    shareService.setupPage({ 
      title: `${publicName} Newsletter #${newsletterId}`,
      isTitlePrefixOn: false,
      tags: twitterTags
    });   

    newslettersService.getNewsletterById(newsletterId, tag)
      .then(newsletter => {
        this.setState({
          isLoading: false,
          isError: false,         
          ...newsletter,
          tweets: (newsletter.tweets || []).map(tweet => {
            return {
              ...tweet,
              html: tweet.html.replace('blockquote ', 'blockquote data-width="300"'),
            };
          }),
        });    
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isError: true
        });
      });        
  }

  render() {
    if (this.state.isLoading) {
      return (
        <section className='regular-page full-newsletter-container'>
          <LoadingIndication />
        </section>
      );
    }

    if (this.state.isError) {
      return (
        <section className='regular-page full-newsletter-container'>
          <div>Newsletter #{this.state._id} not found</div>
          <SiteSubscription source='Newsletter' sourceValue={this.state._id} mailingListKey={ this.state.tag || 'angular' } />          
        </section>
      );
    }

    let { editor, crawledResourcesCounts, articles } = this.state;
    let crawledResourcesChance;
    if (crawledResourcesCounts) {
      crawledResourcesChance = Math.round(articles.length / crawledResourcesCounts * 10000) / 100;

      crawledResourcesCounts = crawledResourcesCounts.toString();
      crawledResourcesCounts = crawledResourcesCounts.length > 3 ? 
      `${ crawledResourcesCounts.slice(0, crawledResourcesCounts.length - 3) },${ crawledResourcesCounts.slice(crawledResourcesCounts.length - 3) }` :
      crawledResourcesCounts;
    } 
      
    editor = (editor && editor.name) ? editor : { name: editor };

    return (
      <section className='regular-page full-newsletter-container'>
        { this.props.isAnimationEnded ? <CustomReadingProgress targetEl='.newsletter-container' /> : ''}

        <section className='newsletter-container'>
          <div className='newsletters-navigation-bar-container'>            
            <NewslettersNavigationBar newsletterId={this.state._id} tag={this.state.tag} />
          </div>

          <div className='date'>{formattersService.formatDate(this.state.date)}</div>
          
          <h3 className='page-title newsletter-title'>Newsletter #{this.state._id}</h3>
          <hr className='title-separator' />

         { 
           crawledResourcesCounts && 
            <section className='newsletter-introduction'>
              <p>
                For the past week, our algorithms crawled <span className='important-part'>{ crawledResourcesCounts } resources</span> over the web. 
                We picked the <span className='important-part'>Top #{ articles.length }</span> for you ({ crawledResourcesChance }% chance).
              </p>
            </section>
         }

          <div className='newsletter-articles'>
          {
            this.state.articles.map((article, i, allArticles) => 
              <div key={i} className='newsletter-article-container'>
                <NewsletterArticle newsletterId={this.state._id} tag={this.state.tag} {...article} />
                <hr />
                {(i === 0 || i === allArticles.length - 1) && <SmartAd />}
                {(i === 1) && <SiteSubscription source='Newsletter' sourceValue={this.state._id} mailingListKey={ this.state.tag || 'angular' } /> }
              </div>
            )
          }
          </div>

          {
            this.state.tweets && this.state.tweets.length > 0 &&
              <div className='newsletter-tweets-container'>
              <h4>Trending Tweets</h4>

              <div className='newsletter-tweets'>
                {
                  this.state.tweets.map((tweet, i) => 
                    <div key={i} className='newsletter-tweet-container'>
                      <EmbededTweetBox {...tweet} />
                    </div>
                  )
                }
              </div>
            </div>
          }

          <section className='writer-section'>
            <TeamMemberBox 
              { ...editor } 
              title={ `Edited by ${ editor.name }` } />
          </section>

          {/* { 
            editor && editor.twitterUserId && 
              <div className="follow-me-in-twitter-container">
                <TwitterFollowButton userId={ editor.twitterUserId } /> 
              </div>            
          } */}

          <SiteSubscription source='Newsletter' sourceValue={this.state._id} mailingListKey={ this.state.tag || 'angular' } />         
        </section>

        {/*<section className='article-suggestions'>
          <ArticleSuggestions articleId={-1} articleTags={[ this.state.tag || 'angular' ]} />
        </section> */}
      </section>
    );
  }
}

Newsletter.propTypes = {
  isAnimationEnded: PropTypes.bool.isRequired
};

const AnimatedNewsletter = AnimatedWrapper(Newsletter);
export default AnimatedNewsletter;